export const shouldInvalidateForActiveUserChange = (
  currentUserId: string | null | undefined,
  nextActiveUserId: string,
): boolean => Boolean(
  currentUserId &&
  nextActiveUserId &&
  currentUserId !== nextActiveUserId
);

export const shouldBlockRestoredUser = (
  browserActiveUserId: string | null,
  restoredUserId: string,
  loginInProgress: boolean,
): boolean => Boolean(
  browserActiveUserId &&
  browserActiveUserId !== restoredUserId &&
  !loginInProgress
);

export const shouldClearImpersonationForAuthTransition = (
  transition: "restore" | "explicit-login",
): boolean => transition === "explicit-login";
